import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { EndPoints } from "../../../../endPoints/endPoints";
import { IPilotList, IPilotNew } from "./IPilots";


export const pilotsApi = createApi({
  reducerPath: "pilots",
  baseQuery: fetchBaseQuery({
    baseUrl: EndPoints.PILOTS,
  }),
  tagTypes: ["pilots", "pilot"],
  endpoints: (builder) => ({
    getAllPilots: builder.query<(IPilotList)[], number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["pilots"],
    }),
    addPilot: builder.mutation<any, IPilotNew>({
      query(body) {
        return {
          url: "",
          method: "POST",
          credentials: "include",
          body,
        };
      },
      invalidatesTags: ["pilots"],
    }),
    getPilot: builder.query<IPilotList, number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["pilot"],
    }),
    editPilot: builder.mutation<IPilotNew & {id: number}, IPilotNew & {id: number}>({
      query({ id, ...body }) {
        return {
          url: `/${id}`,
          method: "PUT",
          credentials: "include",
          body,
        };
      },
      invalidatesTags: ["pilots", "pilot"],
    }),
    deletePilot: builder.mutation<string, number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "DELETE",
          credentials: "include",
        };
      },
      invalidatesTags: ["pilots"],
    }),
  }),
});

export const {
  useAddPilotMutation,
  useDeletePilotMutation,
  useEditPilotMutation,
  useGetAllPilotsQuery,
  useGetPilotQuery
} = pilotsApi;
